import {getPublicProperty} from '@netx/core-app-next/utils/getPublicProperty';
import {AuthPref, AuthPasswordPatternType} from '../constants';

export type AuthPasswordPatternObject = Record<AuthPasswordPatternType, number>;

/**
 * Will create an object indexed by the passowrd pattern type with a valu of the minimum length expected
 * @returns Password Pattern Object
 */
export const getPasswordPatternObject = () => {
	const passwordPattern = getPublicProperty(AuthPref.PASSWORD_PATTERN);

	if (!passwordPattern || passwordPattern === '') return;

	const obj = passwordPattern
		.split(',')
		.reduce<Partial<AuthPasswordPatternObject>>((accum, piece) => {
			piece = piece.trim();
			const patternType = piece.charAt(piece.length - 1);
			const patternLength = parseInt(piece.substring(-1)) || 0;

			// ignore if invalid type or length
			return !patternLength ||
				!Object.values(AuthPasswordPatternType).includes(
					patternType as AuthPasswordPatternType,
				)
				? accum
				: {
						...accum,
						[patternType]: patternLength,
				  };
		}, {});

	return Object.keys(obj).length ? obj : undefined;
};

export default getPasswordPatternObject;
